export default {
  title: 'Date bancare',
  sections: {
    personal_info: 'Informații personale',
    address: 'Adresă',
  },
  labels: {
    account_number: 'Număr de cont',
    routing_number: 'Cod de rutare',
    email: 'E-mail',
    full_name: 'Nume complet',
    street: 'Adresă stradă',
    zip_code: 'Cod poștal',
    city: 'Oraș',
  },
  tooltip: '{{field}} a fost copiat în clipboard!',
};
